import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-flex is-align-items-center is-justify-content-space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CronometroVue = _resolveComponent("CronometroVue")!
  const _component_Botao = _resolveComponent("Botao")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CronometroVue, { "tempo-segundos": _ctx.tempoSegundos }, null, 8, ["tempo-segundos"]),
    _createVNode(_component_Botao, {
      onClicado: _ctx.iniciar,
      color: "success",
      icone: "fas fa-play",
      texto: "play",
      loading: _ctx.cronometroRodando
    }, null, 8, ["onClicado", "loading"]),
    _createVNode(_component_Botao, {
      onClicado: _ctx.finalizar,
      color: "danger",
      icone: "fas fa-stop",
      texto: "stop",
      desabilitado: !_ctx.cronometroRodando
    }, null, 8, ["onClicado", "desabilitado"])
  ]))
}